import {MAKE_OTHER} from '../constants/makeModel';
import type {BaseVehicle} from '../types/BaseVehicle';

/**
 * Helper function to determine the correct make value based on custom make logic
 */
export const getMakeValue = (formData: Pick<BaseVehicle, 'make' | 'formMake' | 'customMake'>) => {
  if (formData.customMake && formData.formMake && formData.customMake === formData.formMake) {
    return MAKE_OTHER;
  }

  return formData.formMake ?? formData.make ?? '';
};
